import type { MeResponse } from '@ucp/web/lib';
import { myWorkAppliesToMe } from '../../lib/myWork/applies';
import { MyActionsLink } from '../ops/MyActionsLink';
import { MyWorkLink } from './MyWorkLink';
import { useMyWorkCount } from './MyWorkCount';

/**
 * The one shell work entry. While My work is on, My actions is hidden even when
 * this caller has nothing on the new page. Flag off restores My actions exactly.
 */
export function ShellWorkLink({
  user,
  variant,
  onNavigate,
  drawerLinkClassName,
}: {
  user: MeResponse;
  variant: 'header' | 'drawer';
  onNavigate?: () => void;
  drawerLinkClassName?: (active: boolean) => string;
}) {
  const count = useMyWorkCount();
  if (user.featureFlags.myWorkEnabled === true) {
    if (!myWorkAppliesToMe(user)) return null;
    return (
      <MyWorkLink
        variant={variant}
        total={count?.total ?? null}
        {...(onNavigate ? { onNavigate } : {})}
        {...(drawerLinkClassName ? { drawerLinkClassName } : {})}
      />
    );
  }
  return (
    <MyActionsLink
      user={user}
      variant={variant}
      {...(onNavigate ? { onNavigate } : {})}
      {...(drawerLinkClassName ? { drawerLinkClassName } : {})}
    />
  );
}
